import { useIsMutating } from 'react-query';

import {
  orderIntentMutationFilter,
  purchaseOrderMutationFilter
} from '@/modules/perseo-billing/components/payment';

export const useMutationStatus = () => {
  const isMutatingOrderIntent = useIsMutating(orderIntentMutationFilter) > 0;
  const isMutatingPurchaseOrder =
    useIsMutating(purchaseOrderMutationFilter) > 0;

  const isMutating = isMutatingPurchaseOrder || isMutatingOrderIntent;

  return isMutating;
};

export default useMutationStatus;
